import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PtlWindowLocationService } from '@ptl/global-components';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-vendor-redirect-modal',
    templateUrl: './vendor-redirect-modal.component.html',
    styleUrls: ['./vendor-redirect-modal.component.scss'],
    standalone: false
})
export class VendorRedirectModalComponent implements OnInit {

  aspName: string = environment.configs.aspName;
  
  constructor(
    private dialogRef: MatDialogRef<VendorRedirectModalComponent>,
    private windowLocationService: PtlWindowLocationService,
    @Inject(MAT_DIALOG_DATA) public data: {
      vendorUrl: string;
    }
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.dialogRef.close();
  }

  goToVendorUrl() {
    this.windowLocationService.goToUrl(this.data.vendorUrl, { newTab: true });
  }

}
